import FieldDefs from './AdsFieldDefs.js'
import {doLangFields} from '../../lib/ks-tools'
import {Listeners} from "../../constants/listeners";
import AdsSelector from "./mixins/Selector";
import Months from "./mixins/Months";

export default {
    template: `<div><slot v-bind="self" /></div>`,
    mixins: [AdsSelector, Months],
    data() {
        return {
            fields: doLangFields(this, "lang.report.ads.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'keyscnt',
                    direction: 'desc'
                }
            ],
            additionalActions: [
                {
                    label: this.$t("lang.report.csv_with_keys"),
                    icon: [],
                    event: function(){
                        this.$emitter.emit(Listeners.KS_TABLE_DOWNLOAD, ["full=true"]);
                    }
                },
            ],
            viewMode: '',
            apiPath: '/report/simple/context/ads',
        }
    },
    computed: {
        self() {
            return this;
        }
    },
}
